import React from "react";
import Slide from "react-reveal/Slide";
import { IList } from "../../../../utils/generalType";
import { inventoryFeatures } from "../Services/service.utils";

const InventoryFeaturesComp = () => {
  const services: IList[] = inventoryFeatures;

  return (
    <section className="relative overflow-hidden bg-slate-950 py-24 text-white">

      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-red-600/20 blur-[150px]" />
        <div className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-orange-500/10 blur-[180px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">

        {/* Header */}

        <div className="max-w-3xl mx-auto text-center">

          <div className="inline-flex items-center rounded-full border border-red-500/30 bg-red-500/10 px-5 py-2 backdrop-blur-xl">

            <span className="mr-2 h-2 w-2 rounded-full bg-red-400 animate-pulse" />

            <span className="text-sm font-medium text-red-300">
              Powerful Features
            </span>

          </div>

          <h2 className="mt-8 text-5xl font-black leading-tight">

            Everything You Need To

            <span className="block bg-gradient-to-r from-red-500 via-orange-400 to-yellow-300 bg-clip-text text-transparent">

              Manage Your Business

            </span>

          </h2>

          <p className="mt-8 text-lg leading-8 text-slate-400">

            SupaRecords combines inventory management,
            accounting, sales, purchasing, reporting,
            and customer management into one powerful
            cloud platform.

          </p>

        </div>

        {/* Features */}

        <div className="mt-20 grid gap-8 md:grid-cols-2 xl:grid-cols-4">

          {services.map((service, index) => (

            <Slide bottom delay={index * 50} key={index}>

              <div className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-8 transition-all duration-500 hover:-translate-y-3 hover:border-red-500/50 hover:bg-white/10 hover:shadow-[0_20px_60px_rgba(239,68,68,.15)]">

                {/* Glow */}

                <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-red-500/10 blur-3xl opacity-0 transition group-hover:opacity-100" />

                {/* Icon */}

                <div className="relative flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-red-600 to-orange-500 text-3xl shadow-lg">

                  {service.icon}

                </div>

                {/* Title */}

                <h3 className="mt-8 text-2xl font-bold">

                  {service.title}

                </h3>

                {/* Description */}

                <p className="mt-5 leading-8 text-slate-400">

                  {service.desc}

                </p>

              </div>

            </Slide>

          ))}

        </div>

        {/* Stats */}

        <div className="mt-24 grid gap-8 rounded-[40px] border border-white/10 bg-white/5 p-10 backdrop-blur-xl md:grid-cols-4">

          <div className="text-center">

            <h3 className="text-5xl font-black text-red-400">
              100%
            </h3>

            <p className="mt-2 text-slate-400">
              Cloud Based
            </p>

          </div>

          <div className="text-center">

            <h3 className="text-5xl font-black text-red-400">
              24/7
            </h3>

            <p className="mt-2 text-slate-400">
              Support
            </p>

          </div>

          <div className="text-center">

            <h3 className="text-5xl font-black text-red-400">
              Multi
            </h3>

            <p className="mt-2 text-slate-400">
              Warehouse
            </p>

          </div>

          <div className="text-center">

            <h3 className="text-5xl font-black text-red-400">
              Live
            </h3>

            <p className="mt-2 text-slate-400">
              Reports
            </p>

          </div>

        </div>

        {/* CTA */}

        <div className="mt-20 text-center">

          <Slide bottom>

            <a
              href="https://admin.suparecords.ng/auth/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 px-10 py-5 text-lg font-semibold text-white shadow-xl transition duration-300 hover:scale-105 hover:shadow-red-500/40"
            >
              Start Free Today
              <span className="ml-3 text-xl">→</span>
            </a>

          </Slide>

        </div>

      </div>

    </section>
  );
};

export default InventoryFeaturesComp;